const prefix = "SYSTEM_";

export const APP_SETTINGS_GET = prefix + "APP_SETTINGS_GET";
export const CLEAR_LEVY_COLLECTION = prefix + "CLEAR_LEVY_COLLECTION";
export const REBUILD = prefix + "REBUILD";
export const SAP_CONFIGURATION_GET = prefix + "SAP_CONFIGURATION_GET";
export const SEED_SAMPLE_INVOICES = prefix + "SEED_SAMPLE_INVOICES";
export const SYSTEM_DETAILS_GET = prefix + "SYSTEM_DETAILS_GET";
export const SYSTEM_DETAILS_REFRESH = prefix + "SYSTEM_DETAILS_REFRESH";
